import { render, staticRenderFns } from "./LogworkModal.vue?vue&type=template&id=08526c9d&scoped=true&"
import script from "./LogworkModal.vue?vue&type=script&lang=js&"
export * from "./LogworkModal.vue?vue&type=script&lang=js&"
import style0 from "./LogworkModal.vue?vue&type=style&index=0&id=08526c9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08526c9d",
  null
  
)

export default component.exports